// extracted by mini-css-extract-plugin
export default {"root":"LnD3eORe"};